import { Chip } from "@/components/Chip/Chip";

type Props = {
  label: string;
};

export const RoomFacilityChip = ({ label }: Props) => (
  <Chip label={label} color="neutral-surface" size="medium" />
);
